import { render, staticRenderFns } from "./sevenPage.vue?vue&type=template&id=ec938aa8&scoped=true&"
import script from "./sevenPage.vue?vue&type=script&lang=js&"
export * from "./sevenPage.vue?vue&type=script&lang=js&"
import style0 from "./sevenPage.vue?vue&type=style&index=0&id=ec938aa8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec938aa8",
  null
  
)

export default component.exports